import devicePlugin from "@evercam/shared/plugins/device"
import { defineNuxtPlugin } from "#app"

export default defineNuxtPlugin(devicePlugin)
